import React from 'react';
import {ReactComponent as CalendarIcon} from '../../../../assets/icons/calendar.svg';
import {ReactComponent as SuccessIcon} from '../../../../assets/icons/success.svg';
import {useTranslation} from "react-i18next";

const StatusCard = ({status}) => {
    const {t} = useTranslation();
    return (
        <div className={status + ' archive__status'}>
            {status === 'planned' ? <CalendarIcon/> : <SuccessIcon/>}

            {status === 'planned' ? <span>{t('all.planned')}</span> : <span>{t('all.sendStatus')}</span>}
        </div>
    );
};

export default StatusCard;
